import { Component, computed, EventEmitter, inject, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { genericFormI } from 'src/app/util/interfaces/genericFormRMK';
import { ModalComponent } from 'src/app/page_component_item/modal/modal.component';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { GenericFormGenModule } from 'src/app/page_component_item/generic-form-gen/generic-form-gen.module';
import { CommonModule } from '@angular/common';
import { mspTableHeaderI } from 'src/app/page_component_item/msp-table/msp-table.component';

@Component({
	selector: 'msp-table-customize-headers',
	standalone: true,
	imports: [CommonModule, ModalComponent, GenericFormGenModule],
	templateUrl: './msp-table-customize-headers.component.html',
	styleUrl: './msp-table-customize-headers.component.scss',
})
export class MspTableCustomizeHeadersComponent implements OnChanges {
	private readonly labelsService = inject(LabelsService);

	@ViewChild('customizeHeaderModal') customizeHeaderModal: ModalComponent;

	labels: { [k: string]: string } = {};
	@Input() availableHeaders: genericFormI['items'][] = [];
	@Input() headers: mspTableHeaderI[] = [];
	headersForm: genericFormI<'multi-select'>;
	headerFormMemory: genericFormI<'multi-select'>;
	@Input() defaultHeaders: string[] = [];

	@Output() saveHeaders = new EventEmitter<genericFormI['items'][]>();

	constructor() {
		this.labels = computed(() => this.labelsService.labels())();

		this.headersForm = new genericFormI('multi-select');
		this.headersForm.id = 'view_columns';
		this.headersForm.name = 'Colunas de Exibição';
		this.headersForm.label = 'lbl_geral_colunas_exibicao';
		this.headersForm.required = true;
		this.headersForm.boxHeight = 180;
		this.headersForm.allowDragAndDrop = true;
		this.headerFormMemory = JSON.parse(JSON.stringify(this.headersForm));
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['availableHeaders'] && changes['availableHeaders'].currentValue) {
			this.headersForm.items = changes['availableHeaders'].currentValue;
			this.headerFormMemory.items = JSON.parse(JSON.stringify(changes['availableHeaders'].currentValue));
			this.headerFormMemory = JSON.parse(JSON.stringify(this.headersForm));
		}

		if (changes['headers'] && changes['headers'].currentValue) {
			this.headersForm.values = [];
			this.headersForm.rawValues = [];
			for (const header of this.headers) {
				const formItem = this.headersForm.items.find((formItem) => formItem.values[0] === header.name);
				if (formItem) {
					this.headersForm.values.push(formItem);
					this.headersForm.rawValues.push(formItem.values[0]);
				}
			}
			this.headerFormMemory = JSON.parse(JSON.stringify(this.headersForm));
		}
	}

	resetHeaderForm() {
		this.headersForm = JSON.parse(JSON.stringify(this.headerFormMemory));
	}

	resetHeaders() {
		this.headersForm.values = this.headersForm.items.filter((item) => this.defaultHeaders.includes(item.values[0]));
		this.headersForm.rawValues = this.headersForm.values.map((item) => item.values[0]);
	}

	fSaveHeaders() {
		this.saveHeaders.emit(this.headersForm.rawValues);
		this.customizeHeaderModal.closeModal();
	}
}
